import { Link } from "react-router-dom";
import { Separator } from "@/components/ui/separator";
import { ArrowUpRight } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_sharda-energy-tech/artifacts/6svyj0b7_logo.svg";

const FOOTER_NAV = [
  { label: "About", id: "about" },
  { label: "Solutions", id: "solutions" },
  { label: "Capabilities", id: "manufacturing" },
  { label: "Industries", id: "industries" },
  { label: "Contact", id: "contact" },
];

const GROUP_LINKS = [
  { label: "Sharda Diesels", path: "/sharda-group" },
  { label: "Sharda Innovest", path: "/sharda-group" },
  { label: "Sharda Infra", path: "/sharda-group" },
];

export default function Footer() {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer" className="relative bg-[#040D1C] border-t border-[#003771]/30 noise-overlay">
      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 py-12 md:py-16 lg:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="mb-6">
              <img src={LOGO_URL} alt="Sharda Energy Tech" className="w-full max-w-[200px] h-auto object-contain" />
            </div>
            <p className="text-xs text-slate-500 leading-relaxed mb-6 max-w-[200px]" style={{ textWrap: "pretty" }}>
              Advanced lithium-ion battery manufacturing and energy storage systems. A Sharda Group enterprise building India's energy future.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h5 className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400 mb-5">
              Navigation
            </h5>
            <ul className="space-y-3">
              {FOOTER_NAV.map((item) => (
                <li key={item.id}>
                  <button
                    data-testid={`footer-nav-${item.id}`}
                    onClick={() => scrollTo(item.id)}
                    className="text-sm text-slate-500 hover:text-[#1E96FC] transition-colors uppercase tracking-wide"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Sharda Group */}
          <div>
            <h5 className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400 mb-5">
              Sharda Group
            </h5>
            <ul className="space-y-3">
              {GROUP_LINKS.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.path}
                    data-testid={`footer-group-${item.label.toLowerCase().replace(/\s/g, "-")}`}
                    className="text-sm text-slate-500 hover:text-[#1E96FC] transition-colors uppercase tracking-wide inline-flex items-center gap-1"
                  >
                    {item.label}
                    <ArrowUpRight className="w-3 h-3" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h5 className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400 mb-5">
              Contact
            </h5>
            <div className="space-y-3 text-sm text-slate-500">
              <p>info@shardaenertech.com</p>
              <p>+91 XXXXX XXXXX</p>
              <p>Industrial Area, India</p>
            </div>
          </div>
        </div>

        <Separator className="my-8 md:my-10 bg-[#003771]/20" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-600 uppercase tracking-wider">
            &copy; {new Date().getFullYear()} Sharda Energy Tech Pvt. Ltd. All rights reserved.
          </p>
          <p className="text-xs text-slate-700 uppercase tracking-wider">
            A Sharda Group Enterprise
          </p>
        </div>
      </div>
    </footer>
  );
}
